import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import AgentCoreLiveView from "../components/Agents/AgentCoreLiveView";

/**
 * Full-page Live View for "Open in new window".
 * Uses a React route (not a static .html) so SPA catch-all /404 cannot swallow it.
 */
const AgentCoreLiveViewPage = () => {
  const location = useLocation();
  const { url, w, h } = useMemo(() => {
    const params = new URLSearchParams(location.search || "");
    return {
      url: params.get("url") || "",
      w: parseInt(params.get("w") || "1440", 10) || 1440,
      h: parseInt(params.get("h") || "900", 10) || 900,
    };
  }, [location.search]);

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        margin: 0,
        padding: 0,
        background: "#111",
        overflow: "hidden",
      }}
    >
      <AgentCoreLiveView
        signedUrl={url}
        remoteWidth={w}
        remoteHeight={h}
        height="100vh"
      />
    </div>
  );
};

export default AgentCoreLiveViewPage;
